import {CostColumnConfiguration} from "./CostColumnConfiguration";
import {DuplicateFieldsConfiguration} from "./DuplicateFieldsConfiguration";

/**
 * ServiceInAdditionListTemplate содержит настройки шаблона
 * `Строка услуги в шаблоне "Дополнительные услуги"`
 */
export class ServiceInAdditionListTemplate {
  /**
   * PositionInList содержит порядковый номер услуги.
   * Данное свойство позволяет менять порядок отображения услуг.
   * Сортировка услуг по данному полю выполняется по возрастанию.
   */
  public PositionInList: number = 0

  /**
   * IsNeedDisplayTextForZeroValues содержит флаг, показывающий, что
   * необходимо вместо нулевой стоимости услуги вывести текст с
   * определенным сообщением.
   */
  public IsNeedDisplayTextForZeroValues: boolean = false

  /**
   * Если включить данный флаг, то услуга не будет отображаться в листинге, когда
   * ее стоимость < 0
   */
  public IsNotVisibleWhenPriceByRequest: boolean = false

  /**
   * DisplayTextForZeroValues содержит локализованный текст для вывода
   * подсказки вместо нулевой стоимости услуги. Включается флагом
   * IsNeedDisplayTextForZeroValues.
   */
  public DisplayTextForZeroValues: string = "Включено в стоимость"

  /**
   * UnitColumnValue содержит локализованный текст для колонки
   * "Единица измерения".
   */
  public UnitColumnValue: string = ""

  /**
   * DuplicateFields содержит подключенные для дублирования в
   * колонке "Количество" поля и их настройки.
   */
  public DuplicateFields: DuplicateFieldsConfiguration = DuplicateFieldsConfiguration.RestoreSettings({})

  /**
   * CostColumn содержит настройки для колонки стоимости услуги.
   */
  public CostColumn: CostColumnConfiguration = CostColumnConfiguration.RestoreSettings({})

  /**
   * Заглушка для запрета прямого создания объектов данного типа
   * @private
   */
  private constructor() {
  }

  /**
   * RestoreSettings выполняет восстановление данных объекта настроек
   * Функция выполняет нормализацию значений настроек.
   * Функция дополняет недостающие настройки значениями по умолчанию.
   *
   * @param data
   */
  public static RestoreSettings(data: any): ServiceInAdditionListTemplate {
    let result = new ServiceInAdditionListTemplate();

    if (typeof data === "string") {
      data = JSON.parse(data)
    }

    if (typeof data !== "object") {
      return result;
    }

    Object.keys(result).map((key: keyof ServiceInAdditionListTemplate) => {
      // @ts-ignore
      result[key] = ServiceInAdditionListTemplate.GetCorrectFieldValue(key, data[key])
    })

    return result;
  }

  /**
   * GetCorrectFieldValue выполняет восстановление данных поля из переданного значения настроек.
   * Данный метод так же проводит валидацию значения каждой из настроек поля. Метод возвращает
   * значение по умолчанию, если значение передано не корректно.
   */
  public static GetCorrectFieldValue<T extends keyof ServiceInAdditionListTemplate>(field: T, data: any): any {
    let defaults = new ServiceInAdditionListTemplate()

    if (data === undefined) {
      return defaults[field]
    }

    switch (field) {
      case "PositionInList":
        return typeof data === "number" && data >= 0 ? data : defaults[field]
      case "IsNeedDisplayTextForZeroValues":
      case "IsNotVisibleWhenPriceByRequest":
        return !!data
      case "DisplayTextForZeroValues":
      case "UnitColumnValue":
        return typeof data === "string" ? data : defaults[field]
      case "CostColumn":
        return CostColumnConfiguration.RestoreSettings(data)
      case "DuplicateFields":
        return DuplicateFieldsConfiguration.RestoreSettings(data)
    }

    return defaults[field];
  }
}